var extend = require('raptor-util/extend');
function objAssign() {
    var target = arguments[0];
    for (var index = 1; index < arguments.length; index++) {
        const src = arguments[index];
        if (src) {
            target = extend(target, src);
        }
    }
    return target;
}

Object.assign = Object.assign || objAssign;

module.exports.objAssign = objAssign;